/**
 * IT Staff Domain Whitelist
 * ---------------------------------------------------------------------------
 * Users whose email matches one of these domains are Irish Taylor (IT) staff.
 * Staff have exclusive access to Approve and Publish / Rollback.
 *
 * Admin Panel access is role-based (admin), not domain-based.
 *
 * To grant a new domain staff-level access, append it to this array.
 * The check is case-insensitive and compares the full domain suffix.
 *
 * Examples:
 *   'irishtaylor.com'       -> matches user@irishtaylor.com
 *   'it-logistics.com'      -> matches admin@it-logistics.com
 */
export const IT_STAFF_DOMAINS: string[] = [
  'irishtaylor.com',
  // 'partner.irishtaylor.com',  // add future domains here
];

/** Matches backend SF_STAFF_TENANT / identity.is_staff_tenant (default name). */
export const STAFF_TENANT_NAME = 'Irish Taylor';

/**
 * Returns true if the given email belongs to an IT staff domain.
 * Safe to call with null / undefined / empty strings — returns false.
 */
export function isITStaffEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const lower = email.toLowerCase().trim();
  return IT_STAFF_DOMAINS.some((domain) => lower.endsWith('@' + domain));
}

/** True when the signed-in org is the Irish Taylor staff tenant (backend rule). */
export function isStaffTenant(tenantName: string | null | undefined): boolean {
  return (tenantName || '').trim().toLowerCase() === STAFF_TENANT_NAME.trim().toLowerCase();
}
